"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var patchIcon_1 = require("../../utils/patchIcon");
var inputTypes = ['text', 'search', 'tel', 'url', 'email', 'password', 'number'];
var propTypes = {
    error: PropTypes.bool,
    type: PropTypes.oneOf(inputTypes),
    adornmentLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
    adornmentRight: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
    alignTextRight: PropTypes.bool
};
/**
 * The `Input` component is a wrapper around the HTML input element for
 * text-based input and should only be used within a [`FormRow`](#!/FormRow)
 * component.
 *
 * The list of available input types is restricted.
 *
 * The component's class name and inline styles are transferred to the root
 * element of the component.
 * All remaining (unknown) properties are passed down to the input element
 * itself.
 */
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            leftAdornmentWidth: 0,
            rightAdornmentWidth: 0
        };
        _this.focus = function () {
            _this.input.focus();
        };
        return _this;
    }
    Input.prototype.componentDidMount = function () {
        this.layoutAdornments();
    };
    Input.prototype.componentDidUpdate = function () {
        this.layoutAdornments();
    };
    Input.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, id = _a.id, className = _a.className, error = _a.error, adornmentLeft = _a.adornmentLeft, adornmentRight = _a.adornmentRight, style = _a.style, alignTextRight = _a.alignTextRight, other = __rest(_a, ["children", "id", "className", "error", "adornmentLeft", "adornmentRight", "style", "alignTextRight"]);
        var componentClassName = classNames('ee_input', {
            'ee_is-invalid': error
        });
        var wrapperClassName = classNames(className, 'ee_input-wrapper');
        var inputStyle = {};
        if (this.state.leftAdornmentWidth) {
            inputStyle.paddingLeft = this.state.leftAdornmentWidth;
        }
        if (this.state.rightAdornmentWidth) {
            inputStyle.paddingRight = this.state.rightAdornmentWidth;
        }
        return (React.createElement("span", { style: style, className: wrapperClassName },
            adornmentLeft && this.renderAdornment(adornmentLeft, 'left'),
            React.createElement("input", __assign({ id: id, "data-focus-id": id, ref: function (input) { return (_this.input = input); }, style: inputStyle, className: componentClassName, "aria-invalid": error, "align-right": alignTextRight ? 'true' : undefined }, other)),
            adornmentRight && this.renderAdornment(adornmentRight, 'right')));
    };
    Input.prototype.renderAdornment = function (adornment, side) {
        var _this = this;
        var instance = typeof adornment === 'string' ? adornment : patchIcon_1.default(adornment, { width: 18, height: 18 });
        return (React.createElement("span", { ref: function (andornmentRef) { return (_this[side + "AdornmentElement"] = andornmentRef); }, className: "ee_input-adornment ee_input-adornment--" + side },
            React.createElement("span", { className: "ee_input-adornment__label" }, instance)));
    };
    Input.prototype.adjustAdornmentPadding = function (element, side) {
        var _a;
        if (element) {
            var newAdornmentWidth = element.getBoundingClientRect().width;
            var stateKey = side + "AdornmentWidth";
            if (newAdornmentWidth !== this.state[stateKey]) {
                this.setState((_a = {},
                    _a[stateKey] = newAdornmentWidth,
                    _a));
            }
        }
    };
    Input.prototype.layoutAdornments = function () {
        this.adjustAdornmentPadding(this.leftAdornmentElement, 'left');
        this.adjustAdornmentPadding(this.rightAdornmentElement, 'right');
    };
    Input.propTypes = propTypes;
    Input.defaultProps = {
        error: false,
        adornmentLeft: undefined,
        adornmentRight: undefined,
        type: 'text',
        alignTextRight: false
    };
    return Input;
}(React.Component));
exports.Input = Input;
exports.default = Input;
//# sourceMappingURL=Input.js.map